// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ga-1{grid-gap:4px;gap:4px}.ga-2{grid-gap:8px;gap:8px}.ga-3{grid-gap:12px;gap:12px}.ga-4{grid-gap:16px;gap:16px}.ga-5{grid-gap:20px;gap:20px}.ga-6{grid-gap:24px;gap:24px}.ga-7{grid-gap:28px;gap:28px}.ga-8{grid-gap:32px;gap:32px}.ga-9{grid-gap:36px;gap:36px}.ga-10{grid-gap:40px;gap:40px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
